<img [fill]="true"
     [ratio]="ratio"
     [dfImage]="mainImage || ''"
     [attr.alt]="altText || ''">

@if (canPrintAltImage()) {
<img class="alt-image"
     [fill]="true"
     [ratio]="ratio"
     [dfImage]="altImage || ''"
     [attr.alt]="altText || ''">
}
